import { parseValidationRule } from '@workspace/lib/validation';

/**
 * Filters an object's entries by evaluating each key against a validation rule condition.
 * @param obj - The target object to filter.
 * @param condition - The validation rule string applied to each key.
 * @returns A new object containing only key-value pairs where the key satisfies the condition.
 */
export function filterObject<T extends object>(
  obj: T,
  condition: string,
): Partial<T> {
  const filtered: Partial<T> = {};
  const validator = parseValidationRule(condition);
  for (const [key, value] of Object.entries(obj)) {
    if (validator(key)) {
      (filtered as Record<string, unknown>)[key] = value;
    }
  }
  return filtered;
}
